import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export function EmptyState({ icon: Icon = Sparkles, title, description, action, testid = "empty-state" }) {
  return (
    <Card data-testid={testid} className="p-8 text-center border-dashed">
      <Icon className="h-7 w-7 mx-auto text-[hsl(var(--aito-lagoon))]" />
      <h3 className="mt-3 font-display text-lg font-semibold">{title}</h3>
      {description && <p className="mt-1 text-sm text-muted-foreground max-w-md mx-auto">{description}</p>}
      {action && <div className="mt-4" data-testid="empty-state-cta">{action}</div>}
    </Card>
  );
}
